var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconAlertTriangleFullYellowmin = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 11,
    x: 10,
    y: 7,
    fill: "#000",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA436",
    d: "M18.693 16.012 13.74 6.106a2 2 0 0 0-3.578 0l-4.953 9.91a2 2 0 0 0 1.789 2.89h9.905a2 2 0 0 0 1.79-2.894M10.95 8.906a1 1 0 0 1 2 0v4a1 1 0 1 1-2 0zm1 8.25a1.25 1.25 0 1 1 0-2.499 1.25 1.25 0 0 1 0 2.499"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconAlertTriangleFullYellowmin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_alert_triangle_full_yellow.min.83cc7d8a8285670c4cd7538e3addb2fa.svg";